import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AdaptorData, ContainerVm, ResourceVm } from 'qp-ui-interface';
import { Observable, from } from 'rxjs';
import { DataService } from '../../data.service';
import { StorefrontService } from '../../storefront/storefront.service';
import { LocalStorageKeys } from '../LocalStorageKeys';
import { ConfigService } from '../services/config/config.service';
import { RecommendationsService } from '../services/firstlight/recommendations/recommendations.service';
import { TabService } from '../services/tabs/tab.service';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

@Injectable()
export class DetailsPageResolver implements Resolve<[ResourceVm, ContainerVm, ContainerVm]> {
  constructor(
    private readonly tabService: TabService,
    private readonly storefrontService: StorefrontService,
    private readonly dataService: DataService,
    private readonly recommendService: RecommendationsService,
    private readonly router: Router,
    private readonly configService: ConfigService,
    private readonly localStorage: LocalStorageService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<[ResourceVm, ContainerVm, ContainerVm]> {
    const detailData = this.fetchDetailsData(route.params.contentType, route.params.id);
    return from(detailData);
  }

  private async fetchDetailsData(contentType: any, id: any): Promise<[ResourceVm, ContainerVm, ContainerVm]> {
    const adaptorData: AdaptorData = {
      resourceType: contentType,
      resourceId: id,
      storefrontId: this.localStorage.getItem(LocalStorageKeys.STOREFRONTID),
      tabId: this.dataService.activeTab,
      tabName: this.tabService.getCurrentTab()?.name,
    };
    const resourceDetailsVm = await this.storefrontService.fetchResourceDetails(adaptorData).catch(() => undefined);

    if (!resourceDetailsVm) {
      this.router.navigate([this.dataService.homeTab]);
      return Promise.reject();
    }
    const moreLikeThisVm = await this.recommendService
      .fetchMoreLikeThis(
        resourceDetailsVm.id, 
        resourceDetailsVm.contentType, 
        resourceDetailsVm.contentGenre, 
        this.configService.applicationConfig.recommendationDetailsAspectRatio ?? '7x10'
      )
      .catch(() => undefined);
    const mostPopularVm = undefined; //await this.recommendService.fetchMostPopular(resourceDetailsVm.contentType).catch(() => undefined);

    return Promise.resolve([resourceDetailsVm, mostPopularVm, moreLikeThisVm]);
  }
}
